import { Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { CrudService } from '../../services/crud.service';
import { DeleteConfirmationComponent } from "../../layout/modals/delete-confirmation/delete-confirmation.component";
import { Observable, Subject } from "rxjs";
import { debounceTime, map, takeUntil } from "rxjs/operators";
import { UploadLinkDialogComponent } from "../../layout/modals/create-video/upload-link-dialog/upload-link-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { UtilityService } from "../../services/utility.service";
import { ToastrService } from "ngx-toastr";
import languages from "../../services/languages";
import { RecordVideoComponent } from "../../layout/modals/record-video/record-video.component";
import { DashboardService } from "../../services/dashboard.service";
import { CreateBadgeComponent } from "../../layout/modals/create-badge/create-badge.component";
import { ActivatedRoute, Router } from "@angular/router";
import { CreateQuestionnaireComponent } from "../../layout/modals/create-questionnaire/create-questionnaire.component";
import { LocalStorageService } from "../../services/localStorage.service";
import { DomSanitizer, SafeUrl, SafeResourceUrl } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { error } from "console";
import sanitizeSVG from "@mattkrick/sanitize-svg";
import { HttpClient } from "@angular/common/http";
import { CreateTranscriptionComponent } from "../ai-agents/create-transcription/create-transcription.component";

declare var $: any;

@Component({
  selector: "app-library",
  templateUrl: "./library.component.html",
  styleUrls: ["./library.component.css"],
  // animations: [fadeInOutAnimation]
})
export class LibraryComponent implements OnInit, OnDestroy {
  @ViewChild("deleteDialogRef") deleteDialogRef: DeleteConfirmationComponent;
  @ViewChild("updateTranscriptDialog") updateTranscriptDialog: any;
  @ViewChild("confirmationDialog") confirmationDialog: any;
  @ViewChildren('fileInput') fileInputs: QueryList<ElementRef>;

  allVideos: Array<any> = [];
  currentVideoObj: any = {};
  showVideo = false;
  spinner = true;
  currentTab:
    | "videos"
    | "ai-editor-videos"
    | "links"
    | "audios"
    | "badges"
    | "documents"
    | "medias"
    | "transcription"
    | "questionnaire" = "videos";
  currentBadgeType: "creation" | "earned" = "earned";
  adminGroups = [];
  currentUserId: string;
  currentGroupIndex = 0;
  aiVideoCount = 0;
  videoCount = 0;
  documentCount = 0;
  imageCount = 0;
  urlCount = 0;
  audioCount = 0;
  earnedBadgeCount = 0;
  creationBadgeCount = 0;
  questionnaireCount = 0;
  transcriptionsCount = 0;
  folderVideoCount = 0;
  allBadges = [];
  allQuestionnaire = [];
  canDownloadLibraryVideo = false;
  isIE = false;
  questionnaire: any = {};
  selectedEarnBadge: any = {};
  doNotShowEditVideoModal = false;
  folderName:any;
  isDisplayFolderInformation:boolean = false;
  folderVideoList:any[] = []
  selectedFolderInfo:any;
  selectedVideoIdForAddingFolder:any[] = [];
  selectedVideoIdForDeletingFolder:any[] = [];
  dropboxParamsValue:any;

  private limit = 15;
  private page = 1;
  sortBy = "recent";
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  public searchText: string;
  language: any;
  textareaData;
  initialValue;
  currentType = "application/x-mpegURL";
  foldersData: any[] = []
  selectFolderIdForMoveVideo: any;
  selectedVideoForForMoveFolder: any;
  userDataWithMe: any;
  transcriptionData: any[] = []

  constructor(
    public apiService: CrudService,
    private dashboardService: DashboardService, 
    private activatedRoute: ActivatedRoute,
    private utilService: UtilityService,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private elRef: ElementRef,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) {
    this.currentUserId = this.localStorageService.getItem("user");
    pdfMake.vfs = pdfFonts.pdfMake.vfs; // Load virtual file system fonts
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.badge && ["earned", "creation"].includes(params.badge)) {
        this.currentBadgeType = params.badge;
      }

      if (params.folderId) {
        this.getFolderInfo(params.folderId);
        this.getUploadedVideoCount();
      }
      // if (!params.folderId || params.folderId === undefined) {
      //   console.log('params.folderId: ', params.folderId);
      //   this.selectedFolderInfo = null;
      //   this.isDisplayFolderInformation = false;
      //   this.folderVideoList = [];
      //   this.demo = true
      //   this.getAllVideos(true);
      // }

      if (
        params.type &&
        [
          "videos",
          "ai-editor-videos",
          "links",
          "audios",
          "badges",
          "questionnaire",
        ].includes(params.type)
      ) {
        this.changeTab(params.type);
      }

      if (params.upload == "dropbox" && params.token) {
        this.dropboxParamsValue = params;
        setTimeout(() => {
          this.openUploadVideo();
          }, 3000);
      }

    });
    this.dashboardService.getSearchTerm
      .pipe(takeUntil(this._unsubscribeAll), debounceTime(1000))
      .subscribe((res) => {
        this.searchText = res;
        if (this.selectedFolderInfo?._id) {
          this.page = 1;
          this.getVideoCountByFolderId(this.selectedFolderInfo?._id);
          this.getFolderData(this.selectedFolderInfo?._id, false);
          this.getUploadedVideoCount();
        } else {
          this.getAllVideos(true);
          this.getQuestionnaire(true)
          this.getTranscriptions(true)
        }
      });
    this.getCheckGroupAdmin();
    this.getUserData();
    // this.getAllVideos(true);

    // WC 07292023 --- To check if the user can download a video in the library or not
    // console.log(this.localStorageService.getItem("membershipName"));

    if (this.localStorageService.getItem("membershipName") == "Gold member")
      this.canDownloadLibraryVideo = true;
    else {
      this.dashboardService.getUserData
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((res) => {
          if (res) {
            // console.log("res = ", res);
            if (res.canDownloadVideo != undefined)
              this.canDownloadLibraryVideo = res.canDownloadVideo;
          }
        });
    }
  }

  getCheckGroupAdmin() {
    this.apiService.getAllGroups({ accessType: "ADMIN" }).subscribe((res) => {
      if (res.data && res.data.length) {
        this.adminGroups = res.data.filter(
          (x) => x.admin !== this.currentUserId
        );
        // console.log(this.adminGroups)
      }
    });
  }

  onScroll(): void {
    ++this.page;
    if (this.currentTab === "badges") {
      this.getBadges();
    } else if (this.currentTab === "questionnaire") {
      this.getQuestionnaire();
    } else if (this.currentTab === "transcription") {
      this.getTranscriptions();
    } else if (this.selectedFolderInfo) {
      this.getFolderData(this.selectedFolderInfo?._id, true)
    }else {
        //console.log("page", this.page)
        this.getAllVideos();
    }

  }

  // Get all videos | links | audios
  getAllVideos(reset = false) {
    this.spinner = true;
    //console.log("reset", reset);
    
    if (reset) {
      this.page = 1;
      this.allVideos = [];
      this.getUploadedVideoCount();
    }
    const object: any = {
      page: this.page,
      limit: this.limit,
      sort: this.sortBy,
      type: "video",
      aiEditorVideo: "no"
    };
    if (this.currentVideoSubTab === "links") {
      object.type = "url";
    } else if (this.currentVideoSubTab === "ai-editor-videos") {
      object.aiEditorVideo = "yes";
    } else if (this.currentVideoSubTab === "audios") {
      object.type = "audio";
    }  else if (this.currentVideoSubTab === "documents") {
      object.type = "pdf";
    } else if (this.currentVideoSubTab === "images") {
      object.type = "image";
    } else if (this.currentTab === "transcription") {
      object.type = "transcriptionFile";
    } 

    if(this.isFolderAddVideos){
      object.folderVideos = true;
    }
    if (this.searchText) {
      object.search = this.searchText;
    }
    this.apiService
      .getLibraryVideos(object)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((success) => {
        for (let i = 0; i < success.data.length; i++) {
          
          if (this.currentVideoSubTab === "audios") {
            success.data[i].poster = "assets/images/wave-audio.png";
          }

          if (success.data[i].subtitleTranslations) {
            success.data[i].subtitleTranslations = success.data[i].subtitleTranslations.map((x) => {
              x.subtitle = languages.find((c) => c.code === Object.keys(x)[0]);
              return x;
            });
            if (success.data[i].subtitleUrl) {
              const defaultLang = this.getDefaultLangTranscription(success.data[i]);
              //WC 06112024 --- Remove adding closed captioning as the subtitle trans causing duplicate
              success.data[i].subtitleTranslations.unshift(defaultLang);
            }
          }
          this.allVideos.push(success.data[i]);
        }
        this.spinner = false;
      });
  }

  getDefaultLangTranscription(video) {
    if (video.subtitleUrl) {
      const defaultLang = this.utilService.getTranscriptLang(video.subtitleUrl);
      const langCode = defaultLang.code.split("-")[0];
      let defaultSubTitle = {
        subtitle: {
          code: langCode,
          disabled: false,
          language: defaultLang.language,
        },
      };
      defaultSubTitle[langCode] = video.subtitleUrl;
      return defaultSubTitle;
    }
  }

  getQuestionnaire(reset?) {
    this.spinner = true;
    if (reset) {
      this.page = 1;
      this.allQuestionnaire = [];
      this.getQuestionnaireCount();
    }
    let object: any = {
      page: this.page,
      limit: this.limit,
      sort: this.sortBy,
    };

    if (this.searchText) {
      object.searchText = this.searchText;
    }
    this.apiService
      .getQuestionnaire(object)
      .subscribe((res: any) => {
        this.allQuestionnaire.push(...res.data);
        // this.badgeCount = res.data.length;
      })
      .add(() => (this.spinner = false));
  }

  getQuestionnaireCount() {
    let obj: any = {}
    // if (this.searchText && this.currentTab === 'questionnaire'){
    if (this.searchText){
      obj.searchText = this.searchText
    }
    this.apiService.getQuestionnaireCount(obj).subscribe((response: any) => {
      this.questionnaireCount = response.data?.[0]?.count || 0;
    });
  }

  getBadges(reset?) {
    this.spinner = true;
    if (reset) {
      this.page = 1;
      this.allBadges = [];
      this.getBadgeCount();
    }
    const object: any = {
      page: this.page,
      limit: this.limit,
      sort: this.sortBy,
      type: this.currentBadgeType,
    };
    this.apiService
      .getBadge(object)
      .subscribe((res: any) => {
        this.allBadges.push(...res.data);
        // this.badgeCount = res.data.length;
      })
      .add(() => (this.spinner = false));
  }

  getBadgeCount() {
    this.apiService.getBadgeCount({}).subscribe((response: any) => {
      this.earnedBadgeCount =
        response.data.find((x) => x.type === "earned")?.count || 0;
      this.creationBadgeCount =
        response.data.find((x) => x.type === "creation")?.count || 0;
    });
  }

  // sort could have the following values: "recent", "name", "size", "duration"
  sortVideos(event: any) {
    this.sortBy = event.target.value;

    
    if (this.currentTab === "badges") {
      this.getBadges(true);
    } else if (this.currentTab === "questionnaire") {
      this.getQuestionnaire(true);
    } else if (this.currentTab === "transcription") {
      this.getTranscriptions(true);
    } else if (this.selectedFolderInfo?._id) {
      this.page = 1;
      this.getFolderData(this.selectedFolderInfo?._id, false)
    } else {
      this.getAllVideos(true);
    }
  }

  backToVideos(){
    this.spinner = true;
    this.sortBy = 'recent';
    this.dashboardService.setSearchTerm = "";
    this.removeFolderIdFromURL();
    // console.log("this.sortBy", this.sortBy);
    this.currentTab='videos'
    this.isDisplayFolderInformation = false;
    this.isFolderAddVideos = false;
    this.selectedFolderInfo = '';
    this.searchText = "";
    this.isBulkAction = false;
    this.selectedVideoListForBulk = [];
    // this.getAllVideos(true);

  }

  showModal(id: any, data?: any) {
    
    if (this.isBulkAction) {
      return
    }

    if(!this.isDisplayFolderInformation){
      this.currentVideoObj = this.allVideos.find((x) => x._id === id);
    }else{
      this.currentVideoObj = this.folderVideoList.find((x) => x._id === id);
    }

    if (this.currentTab === "links") {
      window.open(this.currentVideoObj?.URL, "_blank");
      return;
    }

    
    
    this.currentVideoObj.transcriptLang = this.utilService.getTranscriptLang(
      this.currentVideoObj?.subtitleUrl
    );
    
    $("#preview-Modal").modal("show");
    $("#preview-Modal").unbind("hidden.bs.modal");
    $("#preview-Modal").on("hidden.bs.modal", () => {
      this.currentVideoObj = null;
      this.showVideo = false;
    });
    this.showVideo = true;
    // show video true
  }

  getUploadedVideoCount() {
    // reset the count
    this.videoCount = 0;
    this.urlCount = 0;
    this.documentCount = 0;
    this.imageCount = 0;
    this.aiVideoCount = 0;

    const object: any = {};
    // if (this.searchText && (this.currentVideoSubTab === 'videos' || this.currentTab === 'medias')) {
    if (this.searchText && !this.selectedFolderInfo?._id) {
      object.search = this.searchText;
    }
    this.apiService
      .getLibraryVideosCount(object)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((success) => {
        this.videoCount = 0;
        this.urlCount = 0;
        this.audioCount = 0;
        this.documentCount = 0;
        this.imageCount = 0;
        success.data.forEach((e, i) => {
          const isVideo = Object.values(e).includes("application/octet-stream");
          const isUrl = Object.values(e).includes("url");
          const isAudio = Object.values(e).includes("audio/mpeg");
          const isDocument = Object.values(e).includes("application/pdf");
          const isImages = Object.values(e).includes("image");
          
          if (isVideo) {
            this.videoCount = e.count;
          }
          if (isUrl) {
            this.urlCount = e.count;
          }
          if (isAudio) {
            this.audioCount = e.count;
          }
          if (isDocument) {
            this.documentCount = e.count;
          }
          if (isImages) {
            this.imageCount = e.count;
          }
        });
      });
    const objectAI: any = {
      aiEditorVideo: "yes",
    };
    // if (this.searchText && this.currentVideoSubTab === 'ai-editor-videos') {
    if (this.searchText && !this.selectedFolderInfo?._id) {
      objectAI.search = this.searchText;
    }
    this.apiService
      .getLibraryVideosCount(objectAI)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((success) => {
        success.data.forEach((e, i) => {
          this.aiVideoCount = 0;
          const isVideo = Object.values(e).includes("application/octet-stream");
          if (isVideo) {
            this.aiVideoCount = e.count;
          }
        });
      });
    this.getBadgeCount();
    this.getQuestionnaireCount();
    this.getTranscriptionsCount();
  }

  openConfirmationDelete(item: any) {
    let type: string;
    if (this.currentVideoSubTab === "links") {
      type = "Link";
    } else if (this.currentVideoSubTab === "audios") {
      type = "Audio";
    } else if (this.currentVideoSubTab === "documents") {
      type = "Document";
    } else if (this.currentVideoSubTab === "images") {
      type = "Image";
    } else if (this.currentTab === "transcription") {
      type = "File";
    }
    else {
      type = "Video";
    }

    if(item?.isFolder){
      type = "Folder"
    }

    let title = item?.isFolder ? 'Are you sure you want to delete the folder and its videos?' : `Are you sure you want to delete this ${type.toLowerCase()}?`

    this.deleteDialogRef.open(
      {
        header: `Delete ${type}`,
        title: title,
      },
      (e) => {
        if (e) {
          this.spinner = true;
          if (!item?.isFolder || !item?.folderId){
            this.apiService
              .deletePresignedURL({ id: item._id, s3Url: item?.objectURL })
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe((success) => {
                this.spinner = false;
                this.getAllVideos(true);
                if (this.selectedFolderInfo?._id) {
                  this.folderVideoList = [];
                  this.getFolderData(this.selectedFolderInfo?._id, false)
                }
                this.toaster.success("Deleted successfully");
              }, error => {
                this.spinner = false;
              });
          } else {
            // this.apiService.deleteFolder(item?._id).subscribe((res) =>{
            this.apiService.deleteMultiplePreSignedUrl({ids: [item?._id]}).subscribe((res) =>{
              if (res?.data?.failedCount === 0) {
                this.toaster.success("Folder deleted successfully")
              } else if (res?.data?.successCount === 0 ){
                this.toaster.error(`Unable to delete the videos because they are used in content trees`);
              } else {
                this.toaster.error(`${res?.data?.successCount} videos deleted successfully and ${res?.data?.failedCount -1 } videos can't be deleted beacuse they are used in content trees`);
              }
              this.spinner = false;
              if (this.selectedFolderInfo?._id) {
                this.folderVideoList = [];
                this.getFolderData(this.selectedFolderInfo?._id, false)
              }
              this.getAllVideos(true);
            }, error => {
              this.spinner = false;
            })
          }
        }
      }
    );
  }

  openConfirmationDeleteBadge(item: any) {
    this.deleteDialogRef.open(
      {
        header: `Delete Badge`,
        title: `Are you sure you want to delete this badge?`,
      },
      (e) => {
        if (e) {
          this.apiService
            .deleteBadge(item._id)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((success) => {
              this.getBadges(true);
            });
        }
      }
    );
  }

  changeTab(tab) {
    this.isBulkAction = false;
    this.selectedVideoListForBulk = [];
    this.isDisplayFolderInformation = false;
    this.dashboardService.setActivePage = tab;
    this.currentTab = tab;
    this.removeFolderIdFromURL();
    // this.getQuestionnaireCount()
    if (tab === "badges") {
      this.getBadges(true);
    } else if (tab === "questionnaire") {
      this.currentVideoSubTab = ''
      this.getQuestionnaire(true);
    } else if(tab === "medias"){
      this.currentVideoSubTab = "links"
      this.getAllVideos(true)
    } else if (tab === "transcription") {
      this.currentVideoSubTab = ''
      this.getTranscriptions(true)
    } else {
      this.isFolderAddVideos = false;
      this.selectedFolderInfo = '';
      this.currentVideoSubTab = "videos";
      this.getAllVideos(true);
    }
  }

  currentVideoSubTab:any = "videos";
  changeVideoTab(tab: any) {
    this.isBulkAction = false;
    this.selectedVideoListForBulk = [];
    this.removeFolderIdFromURL();
    //console.log("tab ==> ", tab);

    if(tab === 'videos' || tab === 'ai-editor-videos'){
      this.currentTab = "videos"
    } 

    if(tab === 'links' || tab === 'documents' || tab === 'images'){
      this.currentTab = "medias"
    }
    this.isDisplayFolderInformation = false;
    this.dashboardService.setActivePage = tab;
    this.currentVideoSubTab = tab;
    this.getAllVideos(true);
  }

  removeFolderIdFromURL() {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { folderId: null },  // Set folderId to null to remove it
      queryParamsHandling: 'merge'  // Retain other existing query parameters
    });
  }

  onBadgeTypeChange(type) {
    this.currentBadgeType = type;
    this.getBadges(true);
  }

  onFilterGroup(i) {
    this.currentGroupIndex = i;
    this.getAllVideos(true);
  }

  // video upload end
  openUploadLinkDialog() {
    const dialogRef = this.dialog.open(UploadLinkDialogComponent, {
      width: "65%",
      minHeight: "400px",
      panelClass: "my-dialog",
      height: "auto",
      data: {
        allVideos: null,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAllVideos(true);
      }
    });
  }

  openUploadVideo() {
    this.isBulkAction = false;
    this.selectedVideoListForBulk = [];
    let obj:any = {
      isAIEditor: this.currentVideoSubTab === "ai-editor-videos",
      folderId: this.selectedFolderInfo?._id ? this.selectedFolderInfo?._id : undefined,
      dropboxValue: this.dropboxParamsValue ? this.dropboxParamsValue : undefined
    }

    if (this.currentVideoSubTab === "ai-editor-videos") {
      obj.uploadType = "uploadLibrary";  
    }

    obj.redirectUrl = this.router.url;

    const dialogRef = this.dialog.open(RecordVideoComponent, {
      disableClose: true,
      width: "100%",
      maxWidth: "700px",
      height: "auto",
      data: obj,
      panelClass: 'recored-section',
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        if (this.selectedFolderInfo) {
          this.getFolderData(this.selectedFolderInfo?._id, false);
        }else{
          this.getAllVideos(true);
            // this.apiService.getDoNotShowItem({item: 'VideoEditorPopUp'}).subscribe((res) => {
            //   if(res.data?.length === 0){
            //     $('#editVideoInformationModal').modal('show');
            //   }
            // }) 
        }
      }
    });
  }


  onChangeForShowModal(value:any){
    this.apiService.setDoNotShowItem({item: 'VideoEditorPopUp'}).subscribe()
  }

  redirectToEditPage(){
    this.router.navigate(['video-editor'], {queryParams: {video: this.allVideos[0]._id, redirect: 'library'}})
  }

  openUploadAudioDialog() {
    const dialogRef = this.dialog.open(RecordVideoComponent, {
      disableClose: true,
      width: "100%",
      maxWidth: "800px",
      height: "auto",
      panelClass: 'recored-section',
      data: {
        isAudio: true,
        skipTranscribing: true,
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getAllVideos(true);
      }
    });
  }

  updateTitle(newName, video: any) {
    
    if (!newName) { 
      this.spinner = false;
      this.toaster.error("Name must be required!")
      return;
    }
    
    if (video.name !== newName) {
      const obj = {
        videoID: video._id,
        name: newName,
      };
      this.apiService.updateUploadedVideoName(obj).subscribe((res) => {
        video.name = newName;
        if(video?.isFolder){
          this.toaster.success("Folder name updated successfully!");
        }else{
          this.toaster.success("Title updated successfully!");
        }
      });
    }
  }

  openCreateBadge(badge?) {
    this.selectedEarnBadge = badge;
    if (badge && this.currentBadgeType === "earned") {
      $("#earnedBadgeModal").modal("show");
      return;
    }
    const dialogRef = this.dialog.open(CreateBadgeComponent, {
      width: "100%",
      maxWidth: "1000px",
      height: "auto",
      autoFocus: false,
      data: {
        badge,
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.currentBadgeType = "creation";
        this.getBadges(true);
      }
    });
  }

  openCreateQuestionnaire(questionnaire?) {
    if (this.isBulkAction) {
      return
    }
    const dialogRef = this.dialog.open(CreateQuestionnaireComponent, {
      width: "100%",
      maxWidth: "1000px",
      height: "auto",
      panelClass: "questionnaries-section",
      autoFocus: false,
      data: {
        questionnaire,
      },
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getQuestionnaire(true);
      }
    });
  }

  onSelectFile(event: any, id: string) {
    const file = event.target.files[0];
    console.log('file: ', file);
    if (file.size > 10485760) {
      this.toaster.error("File size should be less than 10MB");
      return;
    }
    if (file) {
      const fileType = file.type;
      if (
        fileType === "image/jpeg" ||
        fileType === "image/jpg" ||
        fileType === "image/png"
      ) {
        const img = new Image();
        img.src = window.URL.createObjectURL(file);
        img.onload = () => {
          if (img.width < 400 || img.height < 150) {
            this.toaster.info("Minimum image size should be 400 x 150");
          } else {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("id", id);
            this.spinner = true;
            this.apiService.uploadWebsiteURLThumbnail(formData).subscribe(
              (res) => {
                this.toaster.success("thumbnail updated successfully !");
                this.getAllVideos(true);
                this.spinner = false;
              },
              (err) => {
                if (err) {
                  this.spinner = true;
                  this.toaster.error(err.error.data);
                }
              }
            );
          }
        };
      } else {
        this.toaster.info("Only jpeg and png files allowed");
      }
    }
  }

  public downloadVideo(video) {
    const payload = {
      videoId: video._id,
      type: "library",
    };

    this.apiService.getOriginalUploadedVideoUrl(payload).subscribe((res) => {
      const filePath = res.data.videoSourceUrl;

      const isInternetExplorer = this.isIE || !!document.DOCUMENT_NODE;

      const pos = video.fullName.lastIndexOf(".");
      const fileExt = video.fullName.substring(pos);

      const fileName = video.name + fileExt;

      if (isInternetExplorer) {
        window.open(filePath, fileName);
      } else {
        const link = document.createElement("a");
        link.download = fileName;
        link.href = filePath;

        link.click();
      }
    });
  }

  onFileChangeEvent(event: any) {
    this.spinner = true;
    let fileList: FileList = event.target.files;

    // Ensure that files are selected
    if (fileList.length === 0) {
      this.spinner = false;
      this.toaster.error("No files selected!");
      return;
    }

    // Loop over each file
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];

      // Check if the file is a PDF
      if (file.type !== 'application/pdf') {
        this.spinner = false;
        this.toaster.error("You can upload only PDF files!");
        return; // Exit if any file does not meet the validation
      }

      const payloadObj = {
        name: file.name,
        type: file.type,
        URL: null,
        duration: 0,
        thumbnail: "",
        size: file.size,
        originalName: file.name,
        isAIEditorVideo: false,
      };

      // Request presigned URL for each file
      this.apiService.createpresignedUrlV2(payloadObj).subscribe((success) => {
        this.apiService.uploadDocument(success.data.details, file).subscribe(() => {
          // After successful upload, perform your operations (e.g., refresh videos)
          if (i === fileList.length - 1) {
            this.spinner = false;
            this.getAllVideos(true); // Ensure it's only called once after all uploads are finished
          }
        }, (error) => {
          this.spinner = false;
          this.toaster.info('Error!', error);
        });
      }, (error) => {
        this.spinner = false;
        this.toaster.error('Error getting presigned URL', error);
      });
    }
  }

  onFileChangeEventForTranscription(event: any) {
    this.spinner = true;
    const file: File | null = event.target.files?.[0] || null;

    // Ensure that files are selected
    if (!file) {
      this.spinner = false;
      this.toaster.error("No file selected!");
      return;
    }

    // Validate file type
    const allowedTypes = ['text/vtt', 'text/csv'];
    const validExtensions = ['vtt', 'csv'];
    const ext = file.name.split('.').pop()?.toLowerCase();

    if (!allowedTypes.includes(file.type) && !validExtensions.includes(ext || '')) {
      this.spinner = false;
      this.toaster.error("Only VTT and CSV files are allowed!");
      return;
    }

    const payloadObj = {
      name: file.name,
      type: file.type,
      URL: null,
      duration: 0,
      thumbnail: "",
      size: file.size,
      originalName: file.name,
      isAIEditorVideo: false,
    };

    // Request presigned URL for each image file
    this.apiService.createpresignedUrlV2(payloadObj).subscribe((success) => {
      this.apiService.uploadTranscriptionFile(success.data.details, file).subscribe(() => {
        this.spinner = false;
        this.getAllVideos(true);
      }, (error) => {
        this.spinner = false;
        console.log('error: ', error);
        this.toaster.info('Error!', error);
      });
    }, (error) => {
      this.spinner = false;
      this.toaster.error('Error getting presigned URL', error);
    });
  }

  async onFileChangeEventForImage(event: any) {
    this.spinner = true;
    let fileList: FileList = event.target.files;

    // Ensure that files are selected
    if (fileList.length === 0) {
      this.spinner = false;
      this.toaster.error("No files selected!");
      return;
    }

    // Loop through each file
    for (let i = 0; i < fileList.length; i++) {
      const fileValue = fileList[i];

      // Validate file type
      if (!['image/jpeg', 'image/png', 'image/jpg'].includes(fileValue.type)) {
        this.spinner = false;
        this.toaster.error("You can upload only jpeg, png, jpg files!");
        return; // Exit if any file does not meet the validation
      }

      const payloadObj = {
        name: fileValue.name,
        type: 'image',
        URL: null,
        duration: 0,
        thumbnail: "",
        size: fileValue.size,
        originalName: fileValue.name,
        isAIEditorVideo: false,
      };

      // Request presigned URL for each image file
      this.apiService.createpresignedUrlV2(payloadObj).subscribe((success) => {
        this.apiService.uploadImage(success.data.details, fileValue).subscribe(() => {
          // After successful upload, check if this is the last file
          if (i === fileList.length - 1) {
            this.spinner = false;
            this.getAllVideos(true); // Ensure it's only called once after all uploads are finished
          }
        }, (error) => {
          this.spinner = false;
          console.log('error: ', error);
          this.toaster.info('Error!', error);
        });
      }, (error) => {
        this.spinner = false;
        this.toaster.error('Error getting presigned URL', error);
      });
    }
  }


  openDoc(url: any) {
    if (this.isBulkAction) {
      return
    }

    window.open(url, '_blank');
  }

  getFolderInfo(folderId:any) {
    this.apiService.getFolderInfo({ folderId: folderId }).subscribe((res: any) => {
      this.spinner = true;
      this.folderVideoCount = 0;
      this.selectedFolderInfo = res.data
      this.spinner = true;
      this.isDisplayFolderInformation = true;
      this.folderVideoList = [];
      this.page = 1;

      this.getVideoCountByFolderId(folderId);
      this.getFolderData(folderId, true);
    }, (error) => {
      this.toaster.error(error.message)
    })
  }

  openFolder(folder:any){
    
    if (this.isBulkAction) {
      return
    }

    this.spinner = true;

    if (this.selectedFolderInfo?._id || this.selectedFolderInfo?._id !== undefined) {
      this.getVideoCountByFolderId(folder?._id);
      this.getFolderData(folder?._id, false);
    }

    this.folderVideoCount = 0;
    this.selectedFolderInfo = folder
    this.spinner = true;
    this.isDisplayFolderInformation = true;
    this.folderVideoList = [];
    this.page = 1;

    // Add folderId as a query parameter in the URL
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { folderId: folder?._id },
      queryParamsHandling: 'merge'
    });

  
  }

  getFolderData(id:any, reset?){
    if(!reset){
      this.spinner = true;
    }
    let obj:any = {
      folderId : id,
      limit: 15,
      page: this.page,
      sort : this.sortBy
    }

    if (this.searchText) {
      obj.search = this.searchText;
    }

    this.apiService.getVideoListByFolderId(obj).subscribe((res) => {
      // console.log("reset ===> ", reset);
      
      this.spinner = false;
      

      for (let i = 0; i < res.data.length; i++) {

        if (this.currentVideoSubTab === "audios") {
          res.data[i].poster = "assets/images/wave-audio.png";
        }

        if (res.data[i].subtitleTranslations) {
          res.data[i].subtitleTranslations = res.data[i].subtitleTranslations.map((x) => {
            x.subtitle = languages.find((c) => c.code === Object.keys(x)[0]);
            return x;
          });
          if (res.data[i].subtitleUrl) {
            const defaultLang = this.getDefaultLangTranscription(res.data[i]);
            //WC 06112024 --- Remove adding closed captioning as the subtitle trans causing duplicate
            res.data[i].subtitleTranslations.unshift(defaultLang);
          }
        }

        // Prevent duplicates
        const isDuplicate = this.folderVideoList.some(video => video._id === res.data[i]._id);
        if (!isDuplicate) {
          if (!reset) {
            this.folderVideoList = res.data;
          } else {
            this.folderVideoList.push(res.data[i]);
          }
        }
          // if (!reset){
          //   this.folderVideoList = res.data
          // }else{
          //   this.folderVideoList.push(...res.data)
          // }
      }

      // if (!reset){
      //   this.folderVideoList = res.data
      // }else{
      //   this.folderVideoList.push(...res.data)
      // }
    })
  }

  getVideoCountByFolderId(id:any) {
    let obj: any = {
      folderId: id
    }

    if (this.searchText) {
      obj.search = this.searchText;
    }

    this.apiService.getVideoCountByFolderId(obj).subscribe((res) => {
      this.folderVideoCount = res.data
    })
  }

  openModalforaddFolder(){
    $('#modalForAddFolder').modal('show');
    this.folderName = '';
  }

  btnAddFolderName(){
    this.spinner = true;
    if(!this.folderName){
      this.spinner = false;
      this.toaster.error("Folder Name must be required!")
      return;
    }
    this.apiService.addFolder({name: this.folderName}).subscribe((res) => {
      this.toaster.success("Folder created successfully!")
      this.getAllVideos(true);
      $('#modalForAddFolder').modal('hide');
      this.isFolderAddVideos = false;
      this.spinner = false;
    })
  }

  isFolderAddVideos:boolean = false;
  allVideoListModal(){
    this.isFolderAddVideos = true;
    this.getAllVideos(true);
    $("#modalForDisplayVideoList").modal('show')
    this.selectedVideoIdForAddingFolder = [];
  }

  selectVideoForFolder(event:any){
    let value = event.target.value
    if(this.selectedVideoIdForAddingFolder.includes(value)){
      this.selectedVideoIdForAddingFolder = this.selectedVideoIdForAddingFolder.filter((i:any) => i !== value)
    }else{
      this.selectedVideoIdForAddingFolder.push(value)
    }
  }

  btnAddVideosToFolder(){
    this.spinner = true;
    let payload = {
      videoIds: JSON.stringify(this.selectedVideoIdForAddingFolder),
      folderId: this.selectedFolderInfo?._id
    }
    this.apiService.addVideoToFolder(payload).subscribe((res) =>{
      this.toaster.success("Videos added successfully!")
      this.openFolder(this.selectedFolderInfo)
      this.spinner = false;
      $("#modalForDisplayVideoList").modal('hide')
    })
  }

  moveVideosToFolder(folder:any){
    this.spinner = true;
    this.folderVideoList = [];
    this.page = 1;
    this.getFolderData(folder?._id, false);
    $('#modalForMoveVideoListToFolder').modal('show')
  }

  
  removeVideoToFolder(event:any){
    let value = event.target.value
    if(this.selectedVideoIdForDeletingFolder.includes(value)){
      this.selectedVideoIdForDeletingFolder = this.selectedVideoIdForDeletingFolder.filter((i:any) => i !== value)
    }else{
      this.selectedVideoIdForDeletingFolder.push(value)
    }
  }
  
  btnMoveVideosToFolder(){
    this.spinner = true;
    this.apiService.removeVideosFromFolder({videoIds: JSON.stringify(this.selectedVideoIdForDeletingFolder)}).subscribe((res)=>{
      this.toaster.success("Videos have been moved from the folder.")
      this.spinner = false;
      $('#modalForMoveVideoListToFolder').modal('hide')
      this.getAllVideos(true);
    })
  }

  generatePdf() {
    const docDefinition = {
      content: [
        { text: 'Hello, world!', style: 'header' },
        'Here is some regular content...',
        { text: 'Here is a list:', style: 'subheader' },
        {
          ol: [
            'Item 1',
            'Item 2',
            'Item 3'
          ]
        }
      ],
      styles: {
        header: {
          fontSize: 22,
          bold: true
        },
        subheader: {
          fontSize: 16,
          bold: true,
          margin: [0, 20, 0, 8] // left, top, right, bottom
        }
      }
    };
    // pdfMake.createPdf(docDefinition).open();
    pdfMake.createPdf(docDefinition).download();
  }

  isShowObjective:boolean = false;
  selectedHoverBadge:any

showObjectivesPopup(data: any) {
    this.selectedHoverBadge = data
    this.isShowObjective = true;
}

hideObjectivesPopup() {        
    if(!this.isShowObjective){
        this.selectedHoverBadge = null;
    }
}

showPopupWithObjective(){
    this.isShowObjective = true
}

hidePopupWithObjective(){
    this.isShowObjective = false
    this.selectedHoverBadge = null;
}

openfoldersModal(video:any){
  this.selectedVideoForForMoveFolder = video;
  this.selectFolderIdForMoveVideo = '';
  this.searchFolder = ""
  $('#foldersModal').modal('show');
  this.spinner = true;
  this.getFolder();
}

  getFolder() {
  this.spinner = true;
  this.foldersData = [];
  let obj: any = {};
  if (this.searchFolder) {
    obj.searchText = this.searchFolder;
  }
  this.apiService.getFolder(obj).subscribe((res) => {
    // console.log("res", res.data);
    this.spinner = false;
    this.foldersData = res.data;
  });
}

FolderForMoveVideo(folder:any){
  this.selectFolderIdForMoveVideo = folder._id
}

btnMoveVideoToFolder(){
  this.spinner = true;
  let payload = {
    videoId: this.selectedVideoForForMoveFolder._id,
    folderId: this.selectFolderIdForMoveVideo
  }

  this.apiService.addVideoToFolder(payload).subscribe((res) =>{
    this.toaster.success("Videos Moved successfully!")
    this.spinner = false;
    this.getAllVideos(true);
    if(this.selectedFolderInfo?._id){
      this.getFolderData(this.selectedFolderInfo?._id, false)
    }
    $("#foldersModal").modal('hide')
    this.foldersData = [];
  })
  }
  
  resetGroupFolderVideos() {
    this.isBulkAction = false;
    this.selectedVideoListForBulk = [];
    this.dashboardService.setSearchTerm = "";
  }

  updateTranscript(id: any) {
    this.spinner = true
    this.textareaData = ""
    if (!this.isDisplayFolderInformation) {
      this.currentVideoObj = this.allVideos.find((x) => x._id === id);
    } else {
      this.currentVideoObj = this.folderVideoList.find((x) => x._id === id);
    }

    this.currentVideoObj.transcriptLang = this.utilService.getTranscriptLang(
      this.currentVideoObj?.subtitleUrl
    );

    this.language = this.currentVideoObj?.subtitleTranslations[0];

    this.getVttFile();
    const dialogRef = this.dialog.open(this.updateTranscriptDialog, {
      width: "100%",
      maxWidth: "700px",
      panelClass: "position-choices",
      height: "auto",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.uploadTranscription();
      }
    });
  }

  getVttFile(url = null) {
    this.apiService
      .getTextData(url || this.language[this.language.subtitle?.code])
      .subscribe((res) => {
        this.spinner = false;
        this.textareaData = res;
        this.initialValue = res;
      });
  }

    uploadTranscription() {
    const url = this.language[this.language.subtitle.code].split("?")[0];
    const formData = new FormData();
    formData.append("inputStr", this.textareaData);
    formData.append("fileName", url);
    this.spinner = true;
    this.apiService.uploadFileToS3(formData).subscribe((res) => {
      this.apiService.getSignedUrl(res.data).subscribe((preSignedUrl) => {
        this.language[this.language.subtitle.code] = preSignedUrl;
      });
      this.toaster.success(res.message);
      this.spinner = false;
    });
  }

  changeLanguage() {
    if (this.textareaData !== this.initialValue) {
      this.confirmationModal();
    } else {
      this.getVttFile();
    }
  }

  confirmationModal() {
    const dialogRef = this.dialog.open(this.confirmationDialog, {
      width: "100%",
      maxWidth: "500px",
      panelClass: "my-dialog",
      height: "auto",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getVttFile();
      }
    });
  }

  isBulkAction:boolean = false;
  selectedVideoListForBulk: any[] = [];
  searchFolder: any;

  changeBulkStatus() {
    this.isBulkAction = !this.isBulkAction 
    this.selectedVideoListForBulk = [];
  }

  selectVideoForBulk(id:any){
    const index = this.selectedVideoListForBulk?.indexOf(id);
    if (index !== -1) {
      this.selectedVideoListForBulk?.splice(index, 1);
    } else {
      this.selectedVideoListForBulk?.push(id);
    }
  }
  
  isShowSelectedVideos(id) {
    return this.selectedVideoListForBulk?.includes(id)
  }
  
  deleteBulkVideos() {
    this.spinner = true;
    let type: string;

    if (this.currentVideoSubTab === "links") {
      type = "Links";
    } else if (this.currentVideoSubTab === "audios") {
      type = "Audios";
    } else if (this.currentVideoSubTab === "documents") {
      type = "Documents";
    } else if (this.currentVideoSubTab === "images") {
      type = "Images";
    } else if (this.currentTab === 'questionnaire') {
      type = "Questionnaires";
    } else if (this.currentTab === "transcription") {
      type = "Files";
    }
    else {
      type = "Videos";
    }

    this.deleteDialogRef.open(
      {
        header: `Delete ${type}`,
        title: `Are you sure you want to delete these selected ${type}?`,
      },
      (e) => {
        if (e) {
          this.spinner = true;

          if(type === "Questionnaires"){
            this.apiService
              .bulkDeleteQuestionnaires({ ids: this.selectedVideoListForBulk })
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe((res) => {
                this.spinner = false;
                this.getQuestionnaire(true);
                this.isBulkAction = false;
                this.selectedVideoListForBulk = [];
                if (res?.data?.failedCount === 0) {
                  this.toaster.success(`${type} are deleted successfully`)
                } else if (res?.data?.successCount === 0) {
                  this.toaster.error(`${type} are unable to be deleted as they are used in content trees`);
                } else {
                  this.toaster.error(`${res?.data?.successCount} ${type} are deleted successfully and ${res?.data?.failedCount} ${type} are unable to be deleted as they are used in content trees`);
                }
              }, error => {
                this.spinner = false;
                this.isBulkAction = false;
                this.selectedVideoListForBulk = [];
              }
            );
          } else if(this.currentTab === "transcription"){
            this.apiService.deleteTranscriptions({ ids: this.selectedVideoListForBulk }).subscribe((success) => {
              this.toaster.success(`Transcription deleted successfully !!`);
              this.spinner = false;
              this.getTranscriptions(true);
              this.isBulkAction = false;
              this.selectedVideoListForBulk = [];
          }, error => {
            this.spinner = false;
            this.isBulkAction = false;
              this.selectedVideoListForBulk = [];
            });
          }
          else{
            this.apiService
              .deleteMultiplePreSignedUrl({ ids: this.selectedVideoListForBulk })
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe((res) => {
                this.spinner = false;
                this.getAllVideos(true);
                if (this.selectedFolderInfo?._id) {
                  this.folderVideoList = [];
                  this.getFolderData(this.selectedFolderInfo?._id, false)
                }
                this.isBulkAction = false;
                this.selectedVideoListForBulk = [];
                if (res?.data?.failedCount === 0) {
                  this.toaster.success(`${type} deleted successfully`)
                } else if (res?.data?.successCount === 0) {
                  this.toaster.error(`${type} are unable to be deleted as they are used in content trees`);
                } else {
                  this.toaster.error(`${res?.data?.successCount} ${type} are deleted successfully and ${res?.data?.failedCount} ${type} are unable to be deleted as they are used in content trees`);
                }
              }, error => {
                this.spinner = false;
                this.isBulkAction = false;
                this.selectedVideoListForBulk = [];
              }
            );
          }
        }
      }
    );
  }

  searchFolderEvent() {
    this.getFolder();
  }

  getUserData() {
    this.apiService.userDetailsV2().subscribe(success => {
      this.userDataWithMe = success.data.details;
    })
  }

  openTranscriptionUploadModal(data?: any) {
    if (this.isBulkAction) {
      return
    }

    const dialogRef = this.dialog.open(CreateTranscriptionComponent, {
      width: "100%",
      maxWidth: "800px",
      height: "auto",
      panelClass: 'recored-section',
      data: data ? data : null
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.getTranscriptionsCount();
        this.getTranscriptions(true);
      }
    });
  }

  getTranscriptions(reset?) {
    this.spinner = true;

    if (reset) { 
      this.page = 1;
      this.transcriptionData = [];
      this.getTranscriptionsCount();
    }

    let object: any = {
      page: this.page,
      limit: this.limit,
      sort: this.sortBy,
    };

    if (this.searchText) {
      object.searchText = this.searchText;
    }

    this.apiService.getTranscriptions(object).subscribe((res) => { 
      this.transcriptionData.push(...res.data.data);
      this.spinner = false;
    }, (err) => {
      this.toaster.error("Failed to fetch transcription d", err);
    });
  }

  getTranscriptionsCount(reset?) {
    let object: any = {};

    if (this.searchText) {
      object.searchText = this.searchText;
    }

    this.apiService.getTranscriptionsCount(object).subscribe((res) => {
      console.log('res: ', res);
      this.transcriptionsCount = res.data.data.count
      this.spinner = false;
    }, (err) => {
      this.toaster.error("Failed to fetch transcription d", err);
    });
  }

  getContentTypeFromUrl(url: string): string | null {
    if (!url) return null;
    try {
      const path = new URL(url).pathname; 
      if (path.endsWith('.vtt')) {
        return 'text/vtt';
      } else if (path.endsWith('.csv')) {
        return 'text/csv';
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
  
  showTooltipForBulkAction() {
    let result;

    if(this.currentTab === 'questionnaire') {
      result = 'Select questionnaires to bulk delete';
    }else if(this.currentTab === 'transcription') {
      result = 'Select files to bulk delete';
    }else {
      result = 'Select videos to bulk delete';
    }
    return result
  }
  
  showTooltipForDeleteBulkAction() {
    let result;

    if(this.currentTab === 'questionnaire') {
      result = 'Delete selected questionnaires';
    }else if(this.currentTab === 'transcription') {
      result = 'Delete selected files';
    }else {
      result = 'Delete selected videos';
    }
    return result
  }
  
  triggerFileInput(i: number) {
    console.log('i: ', i);
    const element = document.getElementById('imgupload' + i);
    console.log('element: ', element);
    if (element) {
      element.click();
    }
  }
}